<script setup lang="ts">
import type { PortableTextVueComponents } from '@portabletext/vue';
import { PortableText } from '@portabletext/vue';
import { h } from 'vue';

import type {
  PortableTextType,
  SanityPortableText,
} from './AppPortableText.model';

interface AppPortableTextProps {
  portableText: SanityPortableText[];
  type: PortableTextType;
}

const props = defineProps<AppPortableTextProps>();

const components: Partial<PortableTextVueComponents> = {
  marks: {
    link: ({ value }, { slots }) => {
      const target = (value?.href || '').startsWith('http')
        ? '_blank'
        : undefined;

      return h(
        'a',
        {
          href: value?.href,
          target,
          rel: target === '_blank' && 'noindex nofollow noreferrer',
        },
        slots.default?.()
      );
    },
  },
};
</script>

<template>
  <div class="app-portable-text" :class="props.type">
    <PortableText :value="props.portableText" :components="components" />
  </div>
</template>

<style lang="scss">
@import '../../styles/_fonts.scss';
.app-portable-text {
  @include font-body-m-light;
  color: var(--color-secondary-60);

  h2 {
    line-height: var(--line-heights-28);
  }
}

.premade-trip {
  h2,
  h3 {
    @include font-heading-5;
    color: var(--color-secondary-60);
  }

  h2 {
    margin-top: var(--spacing-24);
  }

  h3 {
    margin-top: var(--spacing-24);
  }

  p {
    margin-top: var(--spacing-8);

    &:first-child {
      margin-top: 0;
    }
  }
}
.premade-trip-modal {
  h2,
  h3 {
    @include font-heading-5;
    color: var(--color-secondary-60);
  }

  h2 {
    margin-top: var(--spacing-48);
  }

  h3 {
    margin-top: var(--spacing-40);
  }

  p {
    margin-top: var(--spacing-8);

    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
